import { LoaderFunctionArgs, redirect } from "react-router-dom";

import {
    defaultEmptyLocatorDataString,
    locatorWeeks,
    myAxios,
    MyDate,
    weeknum,
} from "src/components/common/functions";

export async function locatorLoader({ params }: LoaderFunctionArgs) {
    const fallbackWeek = weeknum(new MyDate().s());
    const selectedWeek = params.week && locatorWeeks.includes(params.week) ? params.week : fallbackWeek;
    const selectedDay = params.day ?? "";
    const canonicalPath = selectedDay ? `/LMTimeCard/${selectedWeek}/${selectedDay}` : `/LMTimeCard/${selectedWeek}`;
    if (params.week !== selectedWeek) {
        throw redirect(canonicalPath);
    }
    const formData = new FormData();
    formData.append("action", "Read");
    formData.append("week", selectedWeek);
    const res = await myAxios({ fileName: "outside/locator/locator.php", formData });
    if (!res) throw redirect("/");
    const divisionsRes = await myAxios({ fileName: "outside/divisions/readDivisions.php" });
    if (!divisionsRes) throw redirect("/");
    return {
        week: selectedWeek,
        form: JSON.parse(res.data?.[selectedWeek] || defaultEmptyLocatorDataString),
        divisions: Array.isArray(divisionsRes.data) ? divisionsRes.data : [],
    };
}